import { useEffect, useRef, useState } from "react";
import { MeetAvatar } from "./VideoTile.jsx";

function viaLabel(via) {
  if (via === "cli") return "Beagle CLI";
  if (via === "wallet") return "wallet app";
  if (via === "launch") return "Beagle Apps";
  if (via === "web") return "app.beagle.chat";
  return via || "Beagle";
}

function chatTarget(via, links) {
  const fromServer = Array.isArray(links) ? links[0] : null;
  if (fromServer?.href) return fromServer;
  if (via === "cli") return { href: "http://127.0.0.1:8766", label: "Open Beagle chat", hint: "Beagle CLI on this computer" };
  if (via === "web" || via === "launch") return { href: "https://app.beagle.chat", label: "Open Beagle chat", hint: "app.beagle.chat" };
  return null;
}

export function AccountChip({ identity, canHost, chat, onOpenAccount, onOpenHost, onSignOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const via = identity?.via || chat?.via || "";
  const link = chatTarget(via, chat?.links);
  const name = identity?.name || identity?.userId || "You";

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="bm-chipwrap" ref={ref}>
      <button
        type="button"
        className="bm-acct-chip"
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen((v) => !v)}
      >
        <MeetAvatar identity={identity} size={32} />
        <span className="bm-acct-chip-text">
          <span className="bm-acct-chip-name">{name}</span>
          {canHost ? <span className="bm-acct-chip-role">host</span> : null}
        </span>
        <span className="bm-acct-chip-caret" aria-hidden="true">▾</span>
      </button>
      {open ? (
        <div className="bm-acct-menu" role="menu">
          <div className="bm-acct-menu-h">
            <MeetAvatar identity={identity} size={40} />
            <div>
              <div className="bm-acct-chip-name">{name}</div>
              <div className="bm-acct-sub">Signed in via {viaLabel(via)}</div>
            </div>
          </div>
          <button type="button" className="bm-acct-item" role="menuitem" onClick={() => { setOpen(false); onOpenAccount?.(); }}>
            Account
          </button>
          {canHost ? (
            <button type="button" className="bm-acct-item" role="menuitem" onClick={() => { setOpen(false); onOpenHost?.(); }}>
              Host console <span className="bm-hostbadge">HOST</span>
            </button>
          ) : null}
          {link ? (
            <a className="bm-acct-item" role="menuitem" href={link.href} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}>
              {link.label || "Open Beagle chat"} <span aria-hidden="true">↗</span>
            </a>
          ) : null}
          <div className="bm-acct-menu-div" />
          <button type="button" className="bm-acct-item danger" role="menuitem" onClick={() => { setOpen(false); onSignOut?.(); }}>
            Sign out
          </button>
        </div>
      ) : null}
    </div>
  );
}
